var _defs, _g, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _path8, _g2, _path9, _g3, _g4, _g5, _g6, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 212.303,
    height: 177.845,
    viewBox: "0 0 212.303 177.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-2{fill:#fff0ef}.prefix__cls-4{fill:#d52b1e}.prefix__cls-5{fill:#fff}.prefix__cls-14{isolation:isolate}.prefix__cls-9{fill:#d9dbdb}.prefix__cls-10{fill:#ff7065}.prefix__cls-12{fill:#e3f1fe}.prefix__cls-13{fill:#003aa5}.prefix__cls-14{opacity:.73}.prefix__cls-15{fill:#9b1207}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_553",
    "data-name": "Group 553",
    transform: "translate(-1710.776 -344.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_253",
    cx: 71.5,
    cy: 71.5,
    r: 71.5,
    "data-name": "Ellipse 253",
    transform: "translate(1710.776 363)",
    style: {
      fill: "#ffc5c2"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_567",
    d: "M1747.418 470.878a4.88 4.88 0 1 0 4.88 4.88 4.881 4.881 0 0 0-4.88-4.88zm0 6.854a1.971 1.971 0 1 1 1.971-1.97 1.971 1.971 0 0 1-1.971 1.97z",
    className: "prefix__cls-2",
    "data-name": "Path 567"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_568",
    d: "M1878.184 490.624a4.88 4.88 0 1 0 4.88 4.88 4.881 4.881 0 0 0-4.88-4.88zm0 6.855a1.971 1.971 0 1 1 1.971-1.971 1.972 1.972 0 0 1-1.971 1.971z",
    className: "prefix__cls-2",
    "data-name": "Path 568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_569",
    d: "M1918.109 414.833a3.735 3.735 0 1 0 3.736 3.735 3.736 3.736 0 0 0-3.736-3.735zm0 5.246a1.513 1.513 0 1 1 1.513-1.512 1.512 1.512 0 0 1-1.513 1.512z",
    className: "prefix__cls-2",
    "data-name": "Path 569"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_570",
    d: "M1852.317 355.062a3.95 3.95 0 1 0 3.949 3.952 3.95 3.95 0 0 0-3.949-3.952zm0 5.549a1.6 1.6 0 1 1 1.6-1.6 1.6 1.6 0 0 1-1.6 1.6z",
    className: "prefix__cls-2",
    "data-name": "Path 570"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_571",
    d: "M1725.952 447.109a4.153 4.153 0 1 0 4.153 4.153 4.153 4.153 0 0 0-4.153-4.153z",
    className: "prefix__cls-2",
    "data-name": "Path 571"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_572",
    d: "M1892.592 460.858a3.021 3.021 0 1 0 3.022 3.022 3.022 3.022 0 0 0-3.022-3.022z",
    className: "prefix__cls-2",
    "data-name": "Path 572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_573",
    d: "M1792.553 356.3a4.416 4.416 0 1 0 4.416 4.416 4.416 4.416 0 0 0-4.416-4.416z",
    className: "prefix__cls-2",
    "data-name": "Path 573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_574",
    d: "M1816.191 516.237a3.217 3.217 0 1 0 3.217 3.219 3.218 3.218 0 0 0-3.217-3.219z",
    className: "prefix__cls-2",
    "data-name": "Path 574"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_575",
    d: "M1878.466 373.333a3.776 3.776 0 1 0 3.775 3.778 3.778 3.778 0 0 0-3.775-3.778z",
    className: "prefix__cls-2",
    "data-name": "Path 575"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_254",
    cx: 2.149,
    cy: 2.149,
    r: 2.149,
    className: "prefix__cls-2",
    "data-name": "Ellipse 254",
    transform: "translate(1742.559 402.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_576",
    d: "M1919.412 396a3.667 3.667 0 1 0 3.667 3.667 3.665 3.665 0 0 0-3.664-3.667z",
    className: "prefix__cls-2",
    "data-name": "Path 576"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_255",
    cx: 2.34,
    cy: 2.34,
    r: 2.34,
    className: "prefix__cls-2",
    "data-name": "Ellipse 255",
    transform: "translate(1721.551 415.405)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_577",
    d: "M1822.255 348.458l1.47-1.469a1.311 1.311 0 0 0-1.848-1.848l-1.469 1.47-1.469-1.47a1.311 1.311 0 0 0-1.848 1.848l1.469 1.469-1.469 1.469a1.311 1.311 0 0 0 1.848 1.848l1.469-1.469 1.469 1.469a1.311 1.311 0 0 0 1.848-1.848z",
    className: "prefix__cls-2",
    "data-name": "Path 577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_578",
    d: "M1722.219 392.869l1.469-1.469a1.309 1.309 0 0 0-1.847-1.848l-1.47 1.47-1.47-1.47a1.31 1.31 0 0 0-1.848 1.848l1.47 1.469-1.47 1.469a1.31 1.31 0 0 0 1.848 1.848l1.47-1.469 1.47 1.469a1.309 1.309 0 0 0 1.847-1.848z",
    className: "prefix__cls-2",
    "data-name": "Path 578"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_579",
    d: "M1895.548 482.607l1.244-1.244a1.109 1.109 0 0 0-1.569-1.569l-1.244 1.244-1.244-1.244a1.109 1.109 0 0 0-1.569 1.569l1.244 1.244-1.244 1.244a1.11 1.11 0 0 0 1.569 1.57l1.244-1.244 1.244 1.244a1.11 1.11 0 0 0 1.569-1.57z",
    className: "prefix__cls-2",
    "data-name": "Path 579"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_552",
    "data-name": "Group 552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_551",
    "data-name": "Group 551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_537",
    "data-name": "Group 537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_587",
    d: "M1803.343 449.658a4.934 4.934 0 0 1-4.933 4.933 4.932 4.932 0 1 0 9.865 0 4.933 4.933 0 0 1-4.932-4.933z",
    "data-name": "Path 587",
    style: {
      fill: "#ffbe00"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_539",
    "data-name": "Group 539"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_618",
    width: 159.234,
    height: 99.859,
    className: "prefix__cls-4",
    "data-name": "Rectangle 618",
    rx: 5,
    transform: "translate(1748.331 392.477)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_619",
    d: "M0 0H147.256V88.344H0z",
    className: "prefix__cls-5",
    "data-name": "Rectangle 619",
    transform: "translate(1754.32 398.234)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_538",
    "data-name": "Group 538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_620",
    d: "M0 0h171.829a8.771 8.771 0 0 1-8.771 8.771H8.771A8.771 8.771 0 0 1 0 0z",
    "data-name": "Rectangle 620",
    transform: "translate(1742.034 492.336)",
    style: {
      fill: "#ef5a4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_621",
    d: "M0 0h33.85a4.386 4.386 0 0 1-4.386 4.386H4.386A4.386 4.386 0 0 1 0 0z",
    "data-name": "Rectangle 621",
    transform: "translate(1811.023 492.336)",
    style: {
      fill: "#7d3e39"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_588",
    d: "M1750.805 501.107h154.287a8.738 8.738 0 0 0 6.309-2.687H1744.5a8.738 8.738 0 0 0 6.305 2.687z",
    "data-name": "Path 588",
    style: {
      isolation: "isolate",
      fill: "#259aff",
      opacity: 0.2,
      mixBlendMode: "multiply"
    }
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_622",
    d: "M0 0H135.311V13.191H0z",
    className: "prefix__cls-9",
    "data-name": "Rectangle 622",
    transform: "translate(1754.353 441.059)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_623",
    d: "M0 0H71.229V23.968H0z",
    className: "prefix__cls-9",
    "data-name": "Rectangle 623",
    transform: "translate(1754.353 456.567)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_624",
    d: "M0 0H58.456V4.182H0z",
    className: "prefix__cls-9",
    "data-name": "Rectangle 624",
    transform: "translate(1831.208 456.567)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_625",
    d: "M0 0H58.456V4.182H0z",
    className: "prefix__cls-9",
    "data-name": "Rectangle 625",
    transform: "translate(1831.208 463.162)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_626",
    d: "M0 0H58.456V4.182H0z",
    className: "prefix__cls-9",
    "data-name": "Rectangle 626",
    transform: "translate(1831.208 469.757)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_627",
    d: "M0 0H58.456V4.182H0z",
    className: "prefix__cls-9",
    "data-name": "Rectangle 627",
    transform: "translate(1831.208 476.353)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_542",
    "data-name": "Group 542"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_628",
    width: 177.979,
    height: 30.89,
    className: "prefix__cls-10",
    "data-name": "Rectangle 628",
    rx: 2,
    transform: "translate(1731.162 402.741)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_629",
    d: "M2 0h29.38v30.89H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z",
    className: "prefix__cls-4",
    "data-name": "Rectangle 629",
    transform: "translate(1731.162 402.741)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_541",
    "data-name": "Group 541",
    style: {
      opacity: 0.5
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_540",
    "data-name": "Group 540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_589",
    d: "M1768.447 422.352l.943-2.119a6.407 6.407 0 0 0 3.353 1c1.19 0 1.654-.333 1.654-.827 0-1.611-5.776-.435-5.776-4.209 0-1.814 1.48-3.294 4.5-3.294a7.6 7.6 0 0 1 3.686.886l-.885 2.133a6 6 0 0 0-2.815-.784c-1.2 0-1.64.407-1.64.914 0 1.553 5.761.392 5.761 4.136 0 1.771-1.48 3.28-4.5 3.28a8.005 8.005 0 0 1-4.281-1.116z",
    className: "prefix__cls-12",
    "data-name": "Path 589"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_590",
    d: "M1786.7 421.046v2.22h-8.156v-10.159h7.968v2.221h-5.123v1.712h4.513v2.148h-4.513v1.858z",
    className: "prefix__cls-12",
    "data-name": "Path 590"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_591",
    d: "M1795.1 421.292h-4.295l-.8 1.974h-2.932l4.485-10.159h2.829l4.5 10.159h-2.987zm-.841-2.119l-1.306-3.25-1.307 3.25z",
    className: "prefix__cls-12",
    "data-name": "Path 591"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_592",
    d: "M1804.146 420.567h-1.567v2.7h-2.873v-10.16h4.644c2.772 0 4.513 1.437 4.513 3.759a3.371 3.371 0 0 1-1.988 3.207l2.191 3.193h-3.076zm.03-5.2h-1.6v2.975h1.6c1.19 0 1.784-.551 1.784-1.48s-.594-1.491-1.784-1.491z",
    className: "prefix__cls-12",
    "data-name": "Path 592"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_593",
    d: "M1809.922 418.186a5.254 5.254 0 0 1 5.587-5.282 5.369 5.369 0 0 1 4.368 1.916l-1.828 1.654a3 3 0 0 0-2.395-1.19 2.9 2.9 0 0 0 0 5.8 3 3 0 0 0 2.395-1.19l1.828 1.654a5.369 5.369 0 0 1-4.368 1.916 5.254 5.254 0 0 1-5.587-5.278z",
    className: "prefix__cls-12",
    "data-name": "Path 593"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_594",
    d: "M1830.82 413.107v10.159h-2.874V419.3h-3.918v3.962h-2.874v-10.155h2.874v3.817h3.918v-3.817z",
    className: "prefix__cls-12",
    "data-name": "Path 594"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_595",
    d: "M1755.913 426.315l-5.136-5.136a7.181 7.181 0 1 0-1.6 1.6l5.136 5.136zm-15.086-5.205a5.857 5.857 0 1 1 8.284 0 5.865 5.865 0 0 1-8.284 0z",
    className: "prefix__cls-5",
    "data-name": "Path 595"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_549",
    "data-name": "Group 549"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_543",
    "data-name": "Group 543"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_630",
    d: "M0 0H10.808V37.438H0z",
    className: "prefix__cls-13",
    "data-name": "Rectangle 630",
    transform: "rotate(-45 1464.742 -2006.192)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_544",
    className: "prefix__cls-14",
    "data-name": "Group 544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_631",
    d: "M0 0H10.808V37.438H0z",
    className: "prefix__cls-15",
    "data-name": "Rectangle 631",
    transform: "rotate(-45 1464.742 -2006.192)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_545",
    "data-name": "Group 545"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_632",
    width: 15.283,
    height: 21.576,
    className: "prefix__cls-13",
    "data-name": "Rectangle 632",
    rx: 1.059,
    transform: "rotate(-45 1485.01 -2011.419)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_546",
    "data-name": "Group 546"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_633",
    width: 15.283,
    height: 21.576,
    "data-name": "Rectangle 633",
    rx: 1.059,
    transform: "rotate(-45 1485.01 -2011.419)",
    style: {
      opacity: 0.73,
      isolation: "isolate",
      fill: "#d52b1e"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_547",
    "data-name": "Group 547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_596",
    d: "M1853.607 446.176a34.349 34.349 0 1 1 0-48.577 34.389 34.389 0 0 1 0 48.577zm-44.1-44.1a28.015 28.015 0 1 0 39.62 0 28.047 28.047 0 0 0-39.618.002z",
    className: "prefix__cls-13",
    "data-name": "Path 596"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_548",
    className: "prefix__cls-14",
    "data-name": "Group 548"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_597",
    d: "M1853.607 446.176a34.349 34.349 0 1 1 0-48.577 34.389 34.389 0 0 1 0 48.577zm-44.1-44.1a28.015 28.015 0 1 0 39.62 0 28.047 28.047 0 0 0-39.618.002z",
    className: "prefix__cls-15",
    "data-name": "Path 597"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_598",
    d: "M1809.509 402.078a28.015 28.015 0 1 0 39.62 0 28.047 28.047 0 0 0-39.62 0z",
    "data-name": "Path 598",
    style: {
      fill: "#f65757",
      opacity: 0.39
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_599",
    d: "M1809.9 406.582c-6.494 7.986-6.344 22.444-3.764 25.024a6.626 6.626 0 0 0 9.359 0c2.58-2.58 1.842-16.644 1.166-20.23-1.042-5.534-4.181-7.376-6.761-4.794z",
    "data-name": "Path 599",
    style: {
      fill: "#f9f9f9",
      opacity: 0.3
    }
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_550",
    "data-name": "Group 550"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_269",
    cx: 19.501,
    cy: 19.501,
    r: 19.501,
    className: "prefix__cls-10",
    "data-name": "Ellipse 269",
    transform: "translate(1765.899 366.857)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_600",
    d: "M1806.046 364.923a8.23 8.23 0 0 0 8.229 8.23 8.229 8.229 0 0 1-16.459 0 8.23 8.23 0 0 0 8.23-8.23z",
    className: "prefix__cls-10",
    "data-name": "Path 600"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f347fa4f6616aa80187dde849462b80b.svg";
export { ForwardRef as ReactComponent };